var _ellipse, _circle, _rect, _circle2, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContextualization(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 76,
    viewBox: "0 0 75 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 37.8821,
    cy: 37.8975,
    rx: 37,
    ry: 37.5,
    fill: "#E5ECEF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 38.4038,
    cy: 38.9192,
    r: 16.1087,
    stroke: "#619BBA",
    strokeWidth: 0.826087
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 22.7083,
    y: 23.2236,
    width: 10.7391,
    height: 10.7391,
    rx: 0.826087,
    fill: "#619BBA"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 53.6864,
    cy: 37.68,
    r: 6.19565,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.4949 53.7865C40.984 54.1929 40.8497 54.9764 40.2532 55.1968L30.1871 58.916C29.5906 59.1363 28.9792 58.6283 29.0866 58.0016L30.8988 47.4245C31.0062 46.7977 31.7518 46.5222 32.2409 46.9286L40.4949 53.7865Z",
    fill: "#619BBA"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContextualization);
export default __webpack_public_path__ + "static/media/contextualization.a9a8390ed8e34bd00a6df7fb9711c5eb.svg";
export { ForwardRef as ReactComponent };